import { Row, Section } from "anketa-core/group";
import { Translation } from "anketa-core/i18n";
import { OpenQuestion } from "anketa-core/open_question";
import { calculateHostIP, getTranslation } from "../../../../";
import { QuestionsRightsTypes } from "..";

export const generateKula = (
  vpcName: string,
  exanioCidr: string,
  transferCidr: string,
  questionsRights: (q: QuestionsRightsTypes) => void
): Row => {
  const kula = new Section("kula", [
    new Translation("en", "Jumphost"),
    new Translation("de", "Jumphost"),
  ]);
  questionsRights(kula);

  kula.description = [
    new Translation(
      "de",
      getTranslation("de", "anketa.documentation.opsanio.kula.description")
    ),
    new Translation(
      "en",
      getTranslation("en", "anketa.documentation.opsanio.kula.description")
    ),
  ];
  const hostname = `${vpcName}-m0-kula-001`;
  const fqdn = `${hostname}.exanio.net`;
  const baseGroup = new Row(`kula`, [
    new Translation("en", fqdn),
    new Translation("de", fqdn),
  ]);

  const cpeIp = exanioCidr ? calculateHostIP(exanioCidr, 10) : "";

  const ip = new OpenQuestion(`kula_ip`, [
    new Translation("en", "Host IP address"),
    new Translation("de", "Host IP-Adresse"),
  ]);
  questionsRights(ip);

  ip.setFactValue(cpeIp);
  ip.readonly = true;
  baseGroup.addChild(ip);

  const transfer = transferCidr ? calculateHostIP(transferCidr, 1) : "";
  const transferIp = new OpenQuestion(`kula_ip_transfer`, [
    new Translation("en", "Transfer IP address"),
    new Translation("de", "Transfer IP-Adresse"),
  ]);
  questionsRights(transferIp);

  transferIp.setFactValue(transfer);
  transferIp.readonly = true;
  baseGroup.addChild(transferIp);

  kula.addChild(baseGroup);
  return kula;
};
